module.exports = __webpack_public_path__ + "img/icon_beginner.431d49ab.svg";